<div class="flex flex-column">
    <div class="col-12">
        <p-panel header="Code presenti a sistema">
            <ng-template #icons>
                <button pButton class="p-button" (click)="loadData()">Aggiorna stato code</button>
                <button pButton class="p-button-warning" (click)="runTestJob()">Avvia Test Job</button>
            </ng-template>
            <ng-template #content>
                <p-blockUI [target]="content" [blocked]="loading"></p-blockUI>
                <app-blockable-div #content>
                    @if (categories.length > 0) {
                        <p-accordion [multiple]="true">
                            @for (category of categories; track category) {
                                <p-accordion-panel [value]="category">
                                    <p-accordion-header>{{ category }}</p-accordion-header>
                                    <p-accordion-content>
                                        <p-table
                                            class="p-datatable p-datatable-striped p-datatable-sm p-datatable-gridlines"
                                            [value]="getRows(category)"
                                        >
                                            <ng-template pTemplate="header">
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th>Job</th>
                                                    <th>Categoria</th>
                                                    <th>Creato</th>
                                                    <th>Avviato</th>
                                                    <th>Terminato</th>
                                                    <th>Stato</th>
                                                    <th>Errore</th>
                                                </tr>
                                            </ng-template>
                                            <ng-template pTemplate="body" let-item>
                                                <tr>
                                                    <td>{{ obj(item).jobType == 0 ? 'Volatile' : 'Persistente' }}</td>
                                                    <td>{{ obj(item).getJobTypeClass() }}</td>
                                                    <td>{{ obj(item).category }}</td>
                                                    <td>{{ obj(item).createdAt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                                    <td>{{ obj(item).startedAt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                                    <td>{{ obj(item).completedAt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                                    <td>
                                                        @if (!obj(item).startedAt) {
                                                            <i class="fa fa-clock"></i>
                                                        }
                                                        @if (obj(item).running) {
                                                            <i class="fas fa-person-running"></i>
                                                        }
                                                        @if (obj(item).completedAt && !obj(item).hasError) {
                                                            <i class="fas fa-check"
                                                            ></i>
                                                        }
                                                        @if (obj(item).hasError) {
                                                            <i class="fa fa-times"></i>
                                                        }
                                                    </td>
                                                    <td>
                                                        {{ obj(item).errorMessage }}<br>
                                                        @if (obj(item).errorStackTrace) {
                                                            <button pButton class="p-button-text"
                                                                    (click)="showStackTrace(item)">
                                                                <i class="pr-2 fa fa-eye"></i>Mostra stack trace
                                                            </button>
                                                        }
                                                    </td>
                                                </tr>
                                            </ng-template>
                                        </p-table>
                                    </p-accordion-content>
                                </p-accordion-panel>
                            }
                        </p-accordion>
                    } @else {
                        <div>
                            <p>Non sono presenti code a sistema</p>
                        </div>
                    }
                </app-blockable-div>
            </ng-template>
        </p-panel>

    </div>
</div>
